import { store } from './../store/index.js';
import { get } from 'lodash';

export function setStyles(defaultStyle, printableStyle) {
    const isPrintableView = get(store.getState(), 'router.location.query.printableView');
    return isPrintableView !== 'true' ? defaultStyle : printableStyle;
}